import React, { useMemo } from 'react'
import Select from 'react-select'

export const SimpleDropdown = ({
  options = [],
  onChange,
  value,
  placeholder = 'Select value',
  className = '',
  size = 32,
}: {
  options: {
    name: string
    value: string | boolean | number
  }[]
  onChange: (value: string | boolean | number) => void
  value: string | boolean | number
  className?: string
  placeholder?: string
  size?: 32 | 36 | 40
  rightIcon?: React.ReactNode
}) => {
  const selectOptions = useMemo(
    () =>
      options.map((option) => ({ label: option.name, value: option.value })),
    [options],
  )

  return (
    <Select
      value={selectOptions.find((option) => option.value === value)}
      onChange={(selected) => {
        if (selected) {
          onChange(selected.value)
        }
      }}
      options={selectOptions}
      placeholder={placeholder}
      className={className}
      classNamePrefix="react-select"
      styles={{
        control: (base) => ({
          ...base,
          height: `${size}px`,
          minHeight: `${size}px`,
          borderWidth: '.5px',
          fontSize: '14px',
          display: 'flex',
          alignItems: 'center',
          borderRadius: '6px',
          boxShadow: 'none',
          '&:hover': {
            borderColor: base.borderColor,
          },
          '&:focus-within': {
            borderColor: base.borderColor,
            boxShadow: 'none',
            outline: 'none',
          },
        }),
        menu: (base) => ({
          ...base,
          zIndex: 300,
        }),
        option: (base, state) => ({
          ...base,
          color: 'black',
          backgroundColor:
            state.isFocused || state.isSelected ? '#f0f0f0' : 'white',
          '&:hover': {
            backgroundColor: '#f0f0f0',
          },
        }),
        singleValue: (base) => ({
          ...base,
          color: 'black',
        }),
        valueContainer: (base) => ({
          ...base,
          display: 'flex',
          alignItems: 'center',
          padding: '0 8px',
          fontSize: '13px',
        }),
        indicatorsContainer: (base) => ({
          ...base,
          display: 'flex',
          alignItems: 'center',
        }),
        indicatorSeparator: (base) => ({
          ...base,
        }),
        dropdownIndicator: (base) => ({
          ...base,
          marginTop: '-2px',
        }),
        input: (base) => ({
          ...base,
          outline: 'none',
          padding: '0',
          margin: '0',
          '&:focus': {
            outline: 'none',
            boxShadow: 'none',
          },
          boxShadow: 'none !important',
        }),
      }}
    />
  )
}
